module.exports = __webpack_public_path__ + "static/media/montserrat-latin-100-normal.ae59c3dd.woff";